import MessageSender from '../sender'
import BaseMessage from '../message'

export default (callbackId) => async () => {
  const msg = new BaseMessage()
  msg.setPath(`control/retry_callback`)
  msg.setItem('id_callback', callbackId)

  const response = await new MessageSender().doPost(msg)

  return response
}
